import { defineCustomElement } from '@tyler-components-web/core';
import { OptionGroupComponent } from './option-group';
export * from './option-group-constants';
export * from './option-group';
export function defineOptionGroupComponent() {
    defineCustomElement(OptionGroupComponent);
}
